module.exports = __webpack_public_path__ + "static/media/period.96e645e0.png";